import React from "react";

interface ImproveButtonProps {
    title: string;
    description: React.ReactNode;
    icon: string;
}

const TRAINING_DESCRIPTION = (
    <>
        Your model is retraining.
        <br />
        We'll email you when it's ready for review.
    </>
);

interface Options {
    willPublish?: boolean;
    iconStyle?: string;
}

export function getImproveButtonProps(
    isTraining: boolean,
    loading: boolean,
    { willPublish = true, iconStyle = "far" }: Options = {}
): ImproveButtonProps {
    const defaultDescription = willPublish
        ? "Publish and retrain on new data."
        : "Retrain on new data.";

    if (isTraining) {
        return {
            title: "Improve My Model",
            description: TRAINING_DESCRIPTION,
            icon: "far fa-spinner fa-spin"
        };
    }

    if (loading) {
        return {
            title: "Gathering data...",
            description: defaultDescription,
            icon: "far fa-spinner fa-spin"
        };
    }

    return {
        title: "Improve Model",
        description: defaultDescription,
        icon: `${iconStyle} fa-sparkles`
    };
}
